<template>
  <div>
    <a-modal :title="audit ? '需求反馈' : '需求反馈详情'" :visible="is_show" width="60%" @cancel="is_show = false"
      :maskClosable="false" class="gufiiguy">
      <template slot="footer">
        <a-button key="back" @click="is_show = false"> 取消 </a-button>
        <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
        <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
        <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
      </template>
      <div ref="sadsada">
        <a-form-model :model="info" :label-col="labelCol3" :wrapper-col="wrapperCol3">
          <div class="title">
            <span>基本信息</span>
          </div>
          <div class="content">
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="审批标题" class="model_span_form" :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }">
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="审批编号" class="model_span_form" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <span>{{ info.applyCode }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="抄送人" class="model_span_form" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <span>{{ info.ccName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="申请人" class="model_span_form">
                  <span>{{ info.createByName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="公司部门" class="model_span_form">
                  <span>{{ info.companyName }}-{{ info.deptName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="需求对接人" class="model_span_form">
                  <span>{{ info.demandContact }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="联系方式" class="model_span_form">
                  <span>{{ info.contactTel }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="所属系统" class="model_span_form">
                  <span>{{ info.affiliatedSystemName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <!-- <a-form-model-item label="需求处理人" class="model_span_form">
                  <span>{{ info.affiliatedSystem ? affiliated[info.affiliatedSystem - 1].name : '' }}</span>
                </a-form-model-item> -->
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="实施原因" class="model_span_form" :label-col="labelCol2"
                  :wrapper-col="wrapperCol2">
                  <span>{{ info.implementationReasons }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="实施内容" class="model_span_form" :label-col="labelCol2"
                  :wrapper-col="wrapperCol2">
                  <span>{{ info.content }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="实施后预计效果" class="model_span_form" :label-col="labelCol2"
                  :wrapper-col="wrapperCol2">
                  <span>{{ info.expectedEffect }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="图片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div class="view_path_img" v-for="(item, index) in info.vouchers" :key="index"
                    style="display: flex; justify-content: space-between">
                    <div class="view_path_img_margin"></div>
                    <div class="view_path_img_center">
                      <img :src="item.imgUrl" @click="show_img(index, info.vouchers)" />
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div class="view_path" @click="previewFile(item)" v-for="(item, index) in info.attachment"
                    :key="index">
                    {{ item.name }}
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <div class="title" v-if="!audit && recordNumber==1">
            <span>审批记录</span>
          </div>
          <div class="content" v-if="!audit && recordNumber==1">
            <auditModel ref="auditModel"></auditModel>
          </div>
        </a-form-model>
      </div>
    </a-modal>
    <!-- 撤销提示 -->
    <preview ref="preview" />
    <a-modal width="60%" v-model="is_revocation" :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'" on-ok="handleOkReason"
      @cancel="closeVisible">
      <template slot="footer">
        <a-button key="back" @click="closeVisible"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <!-- v-if="result == 2 && record.taskDefKey == ' rd_principal' && record.processDefKey == 'feedback'"  -->
      <a-form-model :model="allform" ref="allFormRef"
        v-if="result == 2 && record.taskDefKey == 'rd_principal' && record.processDefKey == 'feedback'"
        :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="所属公司" prop="companyId" :rules="{
						  required: true,
						  message: '请选择所属公司',
						  trigger: 'change',
						}">
              <a-select allowClear placeholder="请选择" v-model="allform.companyId" @change="chooseDept" show-search
                :filter-option="filterOption">
                <a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index">
                  {{ item.title }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="所属部门" prop="deptId" :rules="{
						  required: true,
						  message: '请选择所属部门',
						  trigger: 'change',
						}">
              <a-select allowClear placeholder="请选择" v-model="allform.deptId" @change="chooseUser" show-search
                :filter-option="filterOption">
                <a-select-option :value="item.deptId" v-for="(item, index) in deptList" :key="index">
                  {{ item.title }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="需求负责人" prop="name" :rules="{
						  required: true,
						  message: '请选择需求负责人',
						  trigger: 'change',
						}">
              <a-select allowClear placeholder="请选择处理该需求的负责人" v-model="allform.name" show-search
                :filter-option="filterOption">
                <a-select-option :value="item.userId" v-for="(item, index) in users" :key="index">
                  {{ item.userName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item allowClear prop="comment" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" :rules="{
						  required: true,
						  message: '请输入审批意见',
						  trigger: 'change',
						}">
              <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" placeholder="请输入审批意见" v-model="allform.comment" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-textarea placeholder="请输入审批意见" v-model="comment" v-else />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
  </div>
</template>
<script>
import auditModel from './audit.vue'
import { getUserList, user_inDepts2 } from '@/api/system'
import { tree_all } from '@/api/purchase'
import { resolveBlob } from '@/utils/index'
import { previewFileLists } from '@/utils/preview.js'
import { download_file_java } from '@/utils/request'

import { feedback_get } from '@/api/financial'
import { getClaimByBusiness, act_task_audit } from '@/api/activiti'
import { act_sku_num } from '@/api/assetmenag'
import { checkPermission } from '@/utils/permissions'
import preview from '@/components/module/prview'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import Watermark from '../../../utils/watermark'
import { axios } from '@/utils/request'

export default {
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    transferModal,
    auditModel
  },
  data() {
    return {
      recordNumber: 0,
      deptList: [],
      companyList: [],
      users: [],
      allform: {
        name: undefined,
        deptId: undefined,
        companyId: undefined,
        comment: ''
      },
      imgUrl: '',
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      is_show: false,
      info: {},
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 18,
      },
      labelCol2: {
        span: 3,
      },
      wrapperCol2: {
        span: 21,
      },
      labelCol3: {
        span: 9,
      },
      wrapperCol3: {
        span: 15,
      },
      record: null,
      assetsExportConsumables: checkPermission('asset:claim:checkSku'),
    }
  },
  activated() { },
  watch: {},
  created() { },
  mounted() {
    console.log(this.assetsExportConsumables)
  },
  methods: {
    //查询下拉列表
    filterOption(input, option) {
      console.log(input, option,)
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    closeVisible() {
      if (this.result == 2 && this.record.taskDefKey == 'rd_principal' && this.record.processDefKey == 'feedback') {
        this.$refs.allFormRef.resetFields()
      }
      this.allform.name = undefined,
        this.allform.deptId = undefined,
        this.allform.companyId = undefined,
        this.allform.comment = ''
      this.is_revocation = false


    },
    chooseDept(e) {
      this.allform.deptId = ''
      this.deptList = []
      this.allform.name = ''
      console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
      this.users = []
      this.companyList.forEach(item => {
        if (item.deptId == e) {
          this.deptList = item.children
        }
      })

    },
    //获取用户列表
    chooseUser(e) {
      this.allform.name = ''
      this.users = []
      console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
      getUserList({
        deptId: e
      }).then(res => {
        if (res.code == 200) {
          for (var i = res.rows.length - 1; i >= 0; i--) {
            if (res.rows[i].status == 1) {
              res.rows.splice(i, 1)

            }
          }
          this.users = res.rows
          console.log(this.users, 'this.users===================================')

        } else {
          this.$message.error(res.msg)
        }
        console.log(res, 'res======================================')

      })
    },
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    }, //预览文件
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },

    // //预览文件
    // previewFile(file) {
    // 	console.log(file, 'file=========================')
    // 	let path = '/' + file.url.split('/')[0] + '/'
    // 		console.log(path, 'path=========================')
    //     let fileName = file.url.substring(file.url.indexOf("/")+1)
    // 	console.log(fileName, 'fileName=========================')
    //       axios({
    //             url: `/file/file/download?bucketName=${file.types}&path=${path}&fileName=${fileName}`,
    //             method: 'post',
    //              responseType: 'blob', // 必须要写
    //             // headers: {
    //             //  'Content-Type': 'application/json;charset=UTF-8'
    //             // }
    //            }).then((res)=>{
    // 			    this.imgUrl = window.URL.createObjectURL(res)
    // 				console.log(this.imgUrl, 'this.imgUrl=========================')
    //                resolveBlob({
    // 				   data:res,
    // 				   headers:{
    // 					   'content-disposition': `attachment;filename=${fileName}`
    // 				   }
    // 				   }) //新窗口打开，借用浏览器去打印
    //            })
    // 	// window.open(file.preUrl)
    // },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    show(record, type = null) {
      this.recordNumber = record.recordNumber
      this.record = record
      feedback_get(record.businessKey).then((res) => {
        console.log(res)
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.info = res.data
        previewFileLists(this.info.vouchers).then((res) => {
          this.info.vouchers = res
        })
        this.is_show = true
        this.$nextTick(() => {
          Watermark.set('安联云管家', this.$refs.sadsada)
          if (!this.audit && this.recordNumber == 1) {
            this.$refs.auditModel.show(record)
          }
        })
      })
    },
    // previewFileLists(fileList) {
    // 	let arr = []
    // 	for(let i=0;i<fileList.length;i++){
    // 		arr.push(new Promise((resolve,rej)=>{
    // 			let path = '/' + fileList[i].url.split('/')[0] + '/'
    // 			let fileName = fileList[i].url.substring(fileList[i].url.indexOf("/")+1)
    // 			  axios({
    // 					url: `/file/file/download?bucketName=${fileList[i].types}&path=${path}&fileName=${fileName}`,
    // 					method: 'post',
    // 					 responseType: 'blob', // 必须要写
    // 				   }).then((res)=>{
    // 					   fileList[i].imgUrl = window.URL.createObjectURL(res)
    // 						resolve(fileList[i])
    // 				   })

    // 		}))
    // 	}
    // 	return Promise.all(arr)
    // },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else if (result_ == 2) {
        //获取公司数据
        tree_all().then(res => {
          if (res.code == 200) {
            this.companyList = res.data[0]
            this.companyList.forEach(item => {
              console.log(item, 'item======================')
              console.log(this.allform.companyId, 'item======================')
              this.allform.companyId = 115
              if (item.deptId == this.allform.companyId) {
                console.log(item.children, 'item======================')
                this.deptList = item.children


                console.log(this.deptList, ' this.deptList this.deptList this.deptList this.deptList this.deptList')
              }
            })
          } else {
            this.$message.error(res.msg)
          }
          console.log(res.data, 'res.data=====================================')

        })
        this.allform.deptId = 137
        getUserList({
          deptId: this.allform.deptId
        }).then(res => {
          if (res.code == 200) {
            for (var i = res.rows.length - 1; i >= 0; i--) {
              if (res.rows[i].status == 1) {
                res.rows.splice(i, 1)

              }
            }
            this.users = res.rows
            console.log(this.deptList, 'this.users===================================')

          } else {
            this.$message.error(res.msg)
          }
        })

        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
      else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
    },
    handleOkReason() {
      if (this.result == 2 && this.record.taskDefKey == 'rd_principal' && this.record.processDefKey == 'feedback') {
        this.$refs.allFormRef.validate(valid => {
          if (valid) {
            if (this.result == 3) {
              if (this.comment == '') {
                this.$message.error('请输入驳回意见！')
              } else {
                this.succeed(this.result)
              }
            } else if (this.result == 2) {
              this.succeed(this.result)
            }
          }
        })

      } else {
        if (this.result == 3) {
          if (this.comment == '') {
            this.$message.error('请输入驳回意见！')
          } else {
            this.succeed(this.result)
          }
        } else if (this.result == 2) {
          this.succeed(this.result)
        }

      }


    },
    //审批
    succeed(result_) {
      if (this.allform.comment) {
        this.comment = this.allform.comment
      }
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: result_,
        businessKey: this.record.businessKey,
        comment: this.comment,
        customizedUserId: this.allform.name,
        taskDefKey: this.record.taskDefKey
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.allform = {}
        this.is_show = false
        this.is_revocation = false
      })
    },
  },
}
</script>
<style lang="less" scoped>
// /deep/ .content {
// 	padding-left: 10px  !important;
// }
// /deep/ .ant-form-item-label {
// 	text-align: left;

// }
</style>
